
<template>
    <div>
        <div class="col-md-12">
            <boton-atras :nombre_ruta="'Menu'"/>
        </div>
        <div class="container text-center mb-5">
            <h1 class="bold300 text-uppercase" style=" font-weight:500;">Informe de Avance Trimestral - Cuenta Pública</h1>
        </div>
        <div>
          <select3Filtros id="selectFiltroIATCP" :data="data" @seleccionado="responseSelectComponent = $event" @titulo="textoTitulo = $event" @fecha="fecha_actualizacion_trim = $event" :placeholder1="'Año'" :placeholder2="'Trimestre'"/>
          <!-- {{ responseSelectComponent }} -->
            <!-- {{dataAniosyTrim}} -->
            <div v-if="dataPorAnioyTrim.length >0" class="mt-3">
                <h5>{{textoTitulo}}</h5>
                <card-collapse-docs :sections="dataPorAnioyTrim[0].contenido_seccion" :urlServe="urlServe" :filtros="2"/>
            </div>
        </div>
        <div class="mt-5"><span v-html="fecha_actualizacion"></span></div>
    </div>
</template>
<script>
import mapFun from '@/common/map-fn-types.js';
import inforAvanTrimCtaPub from "@/services/rendicionDeCuentas/informeAvanceTrimCtaPub/informeAvanceTrimCtaPub.js"
const _serviciosinforAvanTrimCtaPub= new inforAvanTrimCtaPub();
import botonAtras from '../../button-atras.vue';
import select3Filtros from '@/components/selectCompuesto3.vue'
import cardCollapseDocs from '@/components/cardcollapseSubs.vue';
import DateFormat from "@/mixins/dateFormatMixin.js";
export default {
    components: { botonAtras, select3Filtros, cardCollapseDocs},
    mixins: [DateFormat],
    created(){
        window.scrollTo(0, 0);
        this.getAniosYtrim();
    },
    data(){
        return{
          dataPorAnioyTrim: [],
          dataAniosyTrim:[],
          data: [],
          dataAllCtaPub: [],
          responseSelectComponent: { select: "", fecha_actualizacion:'', selectedSeccion: { id: 0, text: "" } },
          textoTitulo: '',
          fecha_actualizacion: '',
          fecha_actualizacion_trim: ''
        }
    },
    methods:{
        async getAniosYtrim() {
            try {
                const response = await _serviciosinforAvanTrimCtaPub.getListadoAniosTrim(mapFun.aniosTrimInfoAvancTrimCtaPub);
                this.fecha_actualizacion = this.DateFormatText(response.data[response.data.length - 1].fecha_actualizacion);
                this.data = response.data.reverse(); //para mostrar los años actuales primeros
                this.data = this.data.map(function (e) {
                return {
                    id:       e.id,
                    text:     e.titulo,
                    fecha_actualizacion: e.fecha_actualizacion,
                    seccion:  e.contenido
                };
              });

            } catch (error) {
                console.log('error', error.message);
            }
        },
        async getAllContenidoTrimCta() {
            try {
                let anio_seleccionado = this.responseSelectComponent.select;
                let ruta = mapFun.contenidoTrimInfoAvancTrimCtaPub;
                let ruta_completa = ruta+anio_seleccionado+".json";
                // console.log("ruta_completa!!!!!!!!!!!!", ruta_completa)
                const response = await _serviciosinforAvanTrimCtaPub.getAllContenido(ruta_completa);
                this.dataAllCtaPub = response.data;
            } catch (error) {
                console.log('error', error.message);
            }
        },
        async getAllContenidoByTrim(){
            await this.dataAllCtaPub.forEach(element => {
                this.dataPorAnioyTrim = element.secciones.filter(itemsec => itemsec.id_seccion == this.responseSelectComponent.selectedSeccion.id);
            });
        }
    },
    watch:{
        'responseSelectComponent.select'(){
            if(this.responseSelectComponent.select != ''){this.getAllContenidoTrimCta();}
        },
        async dataAllCtaPub(){
            await this.getAllContenidoByTrim();
        },
        async 'responseSelectComponent.selectedSeccion.id'(){
            if(this.responseSelectComponent.selectedSeccion){await this.getAllContenidoByTrim();}
            if(this.responseSelectComponent.selectedSeccion.fecha_actualizacion){this.fecha_actualizacion = this.DateFormatText(this.responseSelectComponent.selectedSeccion.fecha_actualizacion);}

        },
        fecha_actualizacion_trim(){
            if(this.fecha_actualizacion_trim != ''){
                this.fecha_actualizacion = this.DateFormatText(this.fecha_actualizacion_trim);
            }
        }
    }
}
</script>